export default __webpack_public_path__ + "static/10-4e884cdd51a14d61e60d9156310a0548.jpg";